module.exports = __webpack_public_path__ + "img/icon-logout.79e69604.svg";